var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIdAuth = function SvgIdAuth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "idAuth_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v925H0V0h1440Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "idAuth_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.44 12.816 1.18 1.178-4.126 4.125-2.946-2.947 1.179-1.178 1.766 1.768 2.947-2.946Zm-6.107-1.774v1.743A5 5 0 0 0 1.667 17.5H0a6.667 6.667 0 0 1 8.333-6.457ZM6.667 0c2.762 0 5 2.237 5 5s-2.238 5-5 5c-2.763 0-5-2.237-5-5s2.237-5 5-5Zm0 1.667a3.332 3.332 0 1 0 0 6.666 3.332 3.332 0 1 0 0-6.666Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#idAuth_svg__a)",
    transform: "translate(-40 -272)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#idAuth_svg__b)",
    transform: "translate(43.333 272.833)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h15.62v18.12H0V0z"
  })))));
};
export default SvgIdAuth;